import { Link } from "react-router-dom";
import styles from "./Sidebar.module.css";
import Icon from "../Icon/Icon";
import { useContext } from "react";
import { NotificationsContext } from "../../shared/Contexts/Notifications/NotificationsContext";

const Sidebar = () => {
  const { noReadNotificationsLength } = useContext(NotificationsContext);
  return (
    <nav className={styles.sidebar} aria-label="main-navigation">
      <ul className={styles.navList}>
        <li>
          <Link to={"/"}>
            <Icon
              name="logo"
              size={74}
              color={"#f2f2f2"}
              className={styles.logoIcon}
            />
          </Link>
        </li>
        <li>
          <Link to={"/admin"} className={styles.navLink}>
            <Icon
              name="home"
              size={40}
              color={"#656565"}
              className={styles.navIcon}
            />
            {noReadNotificationsLength > 0 && (
              <span className={styles.noReadNotificationsLength}>
                {`+${noReadNotificationsLength}`}
              </span>
            )}
          </Link>
        </li>
        <li>
          <Link to={"/settings"}>
            <Icon
              name="settings"
              size={40}
              color={"#656565"}
              className={styles.navIcon}
            />
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
